module.exports = __webpack_public_path__ + "media/images/landings/promotion_5/img-campaign-pc-9b60713e711eb6d31874b3c06d95fd7b.png";